import { Component, OnInit } from '@angular/core';
import { HttpHeaders, HttpParams, HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-report-menu',
  templateUrl: './report-menu.component.html',
  styleUrls: ['./report-menu.component.css']
})
export class ReportMenuComponent implements OnInit {

  constructor(private http: HttpClient) { }
  public _MenuS = [];
  ngOnInit() {
    this.GetMenuReport();
  }
  GetMenuReport() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
    };
    this.http.get<any>("api/_Menu/GetMenuReport").subscribe(res => {
      this._MenuS = res;
    });
  }

}
